import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, registro_no_guardado } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import ModalService from '../../../ModalService/ModalService';
import FormTipoPasatiempo from './FormTipoPasatiempo';

const ModalAddTipoPasatiempo = ({ openAdd, setOpenAdd, agregar, errorTable, nombreModulo }) => {
    
    const [error, setError] = useState(null);

    const cerrarModal = () => {
        setOpenAdd(false);
        setError(null);
    }

    const enviarTipoPasatiempo = tipoPasatiempo => {
        const info = tipoPasatiempo;
        Axios.post(`${servicios_grupogack_catalogo}/pasatiempos/`, info, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    agregar(res.data.dataResponse);
                    setOpenAdd(false);
                    break;
                default:
                    errorTable(registro_no_guardado);
                    break;
            }
        })
        .catch(error => errorTable(registro_no_guardado));
    }

    return (
        <ModalService title="Nuevo Tipo de Pasatiempo" parentNode={nombreModulo}
            isOpen={ openAdd } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormTipoPasatiempo
                        enviarTipoPasatiempo={enviarTipoPasatiempo}
                        error={error}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalAddTipoPasatiempo;